import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { InjectableRxStompConfig, RxStompService } from '@stomp/ng2-stompjs';
import { environment } from 'src/environments/environment';
import { CraftingService } from '../modules/main-game/components/game-modals/services/crafting.service';
import { GameModalService } from '../modules/main-game/components/game-modals/services/game-modal.service';
import { PubService } from '../modules/main-game/components/game-modals/services/pub.service';
import { logout } from '../store/auth/auth.actions';
import {
  IUpdateCharacterSpecs,
  updateCharacterSpecs,
} from '../store/characterState/characterState.actions';
import {
  updateBalance,
  updateCompletedCardState,
} from '../store/mainState/mainState.actions';

// openTopic - /topic/xxxxxxx
// privateTopic - /account/topic/xxxxxxx

export const wsTopics: { name: string; topic: string; isPrivate: boolean }[] = [
  { name: 'balance', topic: 'balance', isPrivate: true },
  { name: 'cityBalance', topic: 'balance/city', isPrivate: false },
  { name: 'card', topic: 'card', isPrivate: true },
  { name: 'character', topic: 'character', isPrivate: true },
  { name: 'character/energy', topic: 'character/energy', isPrivate: true },
  {
    name: 'character/slot/skill',
    topic: 'character/slot/skill',
    isPrivate: true,
  },
  {
    name: 'character/speciality',
    topic: 'character/speciality',
    isPrivate: true,
  },
  { name: 'craft/field', topic: 'building/field/craft', isPrivate: true },
  {
    name: 'craft/greenhouse',
    topic: 'building/greenhouse/craft',
    isPrivate: true,
  },
  {
    name: 'craft/laboratory',
    topic: 'building/laboratory/craft',
    isPrivate: true,
  },
  { name: 'craft/lake', topic: 'building/lake/craft', isPrivate: true },
  {
    name: 'craft/restaurant',
    topic: 'building/restaurant/craft',
    isPrivate: true,
  },
  {
    name: 'task/daily',
    topic: 'building/pub/task/daily',
    isPrivate: true,
  },
];

@Injectable()
export class ApiWebSocketService {
  private rxStompService: RxStompService = new RxStompService();
  private myRxStompConfig: InjectableRxStompConfig = {
    brokerURL: `${environment.apiWss}`,
    heartbeatIncoming: 0,
    heartbeatOutgoing: 20000,
    reconnectDelay: 100000,
    connectHeaders: { 'Access-Token': localStorage['accessToken'] },
    debug: (msg): void => {
      // console.log(msg);
    },
  };
  constructor(
    private store: Store,
    private pubService: PubService,
    private craftingService: CraftingService
  ) {}

  connectWebSockets(): void {
    this.refreshWebsocketToken(localStorage['accessToken']);
    this.rxStompService.activate();
    wsTopics.forEach((topic) => {
      this.rxStompService
        .watch(
          topic.isPrivate
            ? `/account/topic/${topic.topic}`
            : `/topic/${topic.topic}`
        )
        .subscribe((message) => {
          const parsedJsonData = JSON.parse(message.body);
          const buildings = this.craftingService.craftingBuildings.getValue();
          const slot = undefined;
          switch (topic.name) {
            case 'balance':
              this.store.dispatch(
                updateBalance({ WssresponseData: parsedJsonData })
              );
              break;
            case 'card':
              this.store.dispatch(
                updateCompletedCardState({ cardUpdate: parsedJsonData })
              );
              break;
            case 'task/daily':
              this.pubService.updateDailyQuestList(parsedJsonData);
              console.log(parsedJsonData);
              break;
            case 'character':
              this.store.dispatch(
                updateCharacterSpecs({
                  character: { type: 'character', data: parsedJsonData },
                })
              );
              break;
            case 'character/slot/skill':
              this.store.dispatch(
                updateCharacterSpecs({
                  character: { type: 'skill', data: parsedJsonData },
                })
              );

              break;
            case 'character/speciality':
              this.store.dispatch(
                updateCharacterSpecs({
                  character: { type: 'speciality', data: parsedJsonData },
                })
              );
              break;
            case 'character/energy':
              this.store.dispatch(
                updateCharacterSpecs({
                  character: { type: 'energy', data: parsedJsonData },
                })
              );
              break;
            default:
              console.log(topic, JSON.parse(message.body));
              break;
          }
        });
    });
    this.rxStompService.stompErrors$.subscribe((err) => {
      console.log(err);
      this.store.dispatch(logout());
    });
  }

  refreshWebsocketToken(accessToken: string): void {
    this.rxStompService.configure({
      ...this.myRxStompConfig,
      connectHeaders: { 'Access-Token': localStorage['accessToken'] },
    });
  }

  closeConnection(): void {
    this.rxStompService.deactivate();
  }
}
